import * as React from 'react';
import { formatValue } from './formatValue';

export const fromEventToFormField = ({ currentTarget }: React.SyntheticEvent<HTMLInputElement>) => {
  const { name, value } = currentTarget;
  const formattedValue = formatValue(name, value);

  return {
    [name]: {
      isError: false,
      value: formattedValue,
    },
  };
};
